import React from "react";
import "./BIDPlayIcon.css";

export default function BIDPlayIcon() {
  return (
    <div className="pi-container">
      <div className="pi-wrapper">
        <svg
          width="20"
          height="24"
          viewBox="0 0 20 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.2504 10.2991C19.5142 11.0809 19.5142 12.9191 18.2504 13.7009L3.05215 23.1024C1.71974 23.9266 0 22.9682 0 21.4015V2.59852C0 1.0318 1.71974 0.0734341 3.05215 0.897644L18.2504 10.2991Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
  );
}
